export const FETCH_COUPON_LIST = 'coupons/FETCH_COUPON_LIST';
export const FETCH_COUPON_LIST_SUCCESS = 'coupons/FETCH_COUPON_LIST_SUCCESS';

export const DEACTIVATE_COUPON = 'coupons/DEACTIVATE_COUPON';

export const CREATE_COUPON = 'coupons/CREATE_COUPON';
